import { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "redux-share";
import { shallowEqual } from "react-redux";
import { setWatchedTime } from "redux-share/slices/videoDataSlice";

const useWatchingDuration = () => {

    const watchedDurationRef = useRef<null | number[]>(null);
    const dispatch = useAppDispatch();
    const { duration, currentTime } = useAppSelector(({ controller: { duration, currentTime } }) => ({ duration, currentTime }), shallowEqual);
    const counter = useRef(0);

    useEffect(() => {
        if (duration) {
            watchedDurationRef.current = new Array(Math.floor(duration)).fill(0);
        }
    }, [duration]);

    useEffect(() => {
        handleUpdateWatchedDuration(Math.floor(currentTime));
    }, [currentTime]);
    
    const handleUpdateWatchedDuration = (index: number) => {
        if (watchedDurationRef.current) {
            const item = watchedDurationRef.current[index];
            if (!item) {
                watchedDurationRef.current[index] = 1;
                counter.current = counter.current + 1;
                dispatch(setWatchedTime(counter.current));
            }
        }
    }
}

export default useWatchingDuration;